/**
 * @description 日志检索 logRetrieve
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const logRetrieveBiz = new Logic()

logRetrieveBiz.getS3logList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.getS3logList,
    data: data
  })
}

logRetrieveBiz.getOfflineTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.getOfflineTask,
    data: data
  })
}

logRetrieveBiz.saveOfflineTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.saveOfflineTask,
    data: data
  })
}

logRetrieveBiz.syncLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.syncLog,
    data: data
  })
}

logRetrieveBiz.deleteOfflineTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.deleteOfflineTask,
    data: data
  })
}

logRetrieveBiz.getKibanaAccount = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.getKibanaAccount,
    data: data
  })
}

logRetrieveBiz.saveKibanaAccount = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.saveKibanaAccount,
    data: data
  })
}

logRetrieveBiz.getS3Uri = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.getS3Uri,
    data: data
  })
}

logRetrieveBiz.getStatistics = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.getStatistics,
    data: data
  })
}

logRetrieveBiz.metricLogs = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.logRetrieve.metricLogs,
    data: data
  })
}

export default logRetrieveBiz
